// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__2BvQY","requiredAsterisk":"Info_requiredAsterisk__ikOZp"};